<template>
  <div>
    <!-- 标题栏 -->
    <div class="searchBox">
      <div>
        <el-date-picker v-model="today" type="daterange" range-separator="至" :clearable="false" :editable="false"
          start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp" @change="search"></el-date-picker>
      </div>
      <div>
        <el-button type="success" size="small" style="margin-left: 10px" @click="toexcel">表格导出</el-button>
      </div>
    </div>

    <div class="mainBox" style="display: flex; padding: 0; height: 100%">
      <div style="width: calc(100%); padding: 20px; height: calc(100vh - 50px - 113px)" v-loading="listLoading">
        <el-table :data="list" element-loading-text="Loading" fit highlight-current-row border height="100%" style="width: 100%">
          <el-table-column align="center" label="类别" min-width="100" prop="leibie"></el-table-column>
          <el-table-column align="center" label="客户" min-width="100" prop="kehu"></el-table-column>
          <el-table-column align="center" label="合同号" min-width="100" prop="hetonghao"></el-table-column>
          <el-table-column align="center" label="伞型" min-width="100" prop="sanxing"></el-table-column>
          <el-table-column align="center" label="产品规格" min-width="100" prop="chanpinguige"></el-table-column>
          <el-table-column align="center" label="喷涂颜色" min-width="100" prop="pentuyanse"></el-table-column>
          <el-table-column align="center" label="颜色" min-width="100" prop="yanse"></el-table-column>
          <el-table-column align="center" label="合同数量" min-width="100" prop="hetongshuliang"></el-table-column>
          <el-table-column align="center" label="工序" min-width="100" prop="gongxu"></el-table-column>
          <el-table-column align="center" label="单伞用量" min-width="100" prop="dansanyongliang"></el-table-column>
          <el-table-column align="center" label="标准量" min-width="100" prop="biaozhunliang"></el-table-column>
          <el-table-column align="center" label="执行单价" min-width="100" prop="zhixingdanjia"></el-table-column>
          <el-table-column align="center" label="成控单价" min-width="100" prop="chengkongdanjia"></el-table-column>
          <el-table-column align="center" label="期初外协/库存核销" min-width="100" prop="qichukucun"></el-table-column>
          <el-table-column align="center" label="期初产量" min-width="100" prop="qichuchanliang"></el-table-column>
          <el-table-column align="center" label="期初金额" min-width="100" prop="qichujine"></el-table-column>
          <el-table-column align="center" v-for="(item,index) in listObj" :key="index"
            :label="item" min-width="100" :prop="item"></el-table-column>
          <el-table-column align="center" label="订单欠量" min-width="100" prop="dingdanqianliang"></el-table-column>
          <el-table-column align="center" label="累计外协/库存核销" min-width="100" prop="leijikucun"></el-table-column>
          <el-table-column align="center" label="累计产量" min-width="100" prop="leijichanliang"></el-table-column>
          <el-table-column align="center" label="累计金额" min-width="100" prop="leijijine"></el-table-column>
        </el-table>
      </div>
    </div>

    
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      url: this.$host,
      list: null,
      pageNum: 1,
      pageSize: 20,
      total: 0,
      listLoading: true,
      keyword: "",
      keywordType: 1,
      today: '',
      sf: '',
      listObj: [],
    }
  },

  created() {
    let today = new Date()
    let todayDate = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate()
    let todayTime = new Date(todayDate).getTime()
    this.today = [todayTime,todayTime];
    this.sf = localStorage.sf
    this.getList()
    
    
  },

  methods: {
    toexcel() {
      this.listLoading = true
      let data = {
        begin: parseInt(this.today[0]/1000),
        end: parseInt(this.today[1]/1000),
      }
      axios.post(this.$host+'/index.php/admin/Zidingyiribaoexcel/zdyrbbaozhuangExcel', data,
        {
          responseType: "blob", //二进制流
        }).then((res) => {
        const fileName = '包装日报汇总表';
        this.downloadFile(res.data, fileName);
        this.listLoading = false
      }).catch(err => {
        console.log(err)
      })
    },
    
    // 下载文件
    downloadFile(blobData, fileName) {
      // 创建Blob对象
      const blob = new Blob([blobData], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      
      // 创建下载链接
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName; // 设置文件名
      
      // 触发下载
      document.body.appendChild(a);
      a.click();
      
      // 清理资源
      document.body.removeChild(a);
      URL.revokeObjectURL(url); // 释放URL对象
    },
    
    search() {
      this.pageNum = 1
      this.getList()
    },
    
    reset() {
      this.keyword = ""
      this.search()
    },
    
    pageChange(page) {
      this.pageNum = page
      this.getList()
    },

    pageSizeChange(size) {
      this.pageSize = size
      this.getList()
    },

    getList() {
      this.listLoading = true
      let data = {
        begin: parseInt(this.today[0]/1000),
        end: parseInt(this.today[1]/1000),
      }
      this.$request.post('/index.php/admin/Zidingyiribao/zdyrbbaozhuang', data).then((res) => {
        this.list = res.data.data
        this.listObj = res.data.listObj
        this.listLoading = false
      }).catch(err => {
        console.log(err)
      })
    },
  },
}
</script>
<style scoped="">

</style>
